import { SEND_CLAIM_SUBMISSION_MAIL, SEND_DOCUMENTS } from "../../../actions/allsureHomeClaim/policyRequest"
import { sendClaimSubmissionService } from "./claimSubmissionService"
import { uploadDocumentsService } from "./uploadDocumentsService"


export const allsureHomeClaimServices=(store, next, action)=>{
   
if (action.type===SEND_CLAIM_SUBMISSION_MAIL) sendClaimSubmissionService(store, next, action)
if (action.type===SEND_DOCUMENTS) uploadDocumentsService(store, next, action)

return null
}
